import React from "react";
import InlineSVG from "svg-inline-react";
import DragdropIcon from "../../Icons/DragdropIcon";

export const DropArea = (
  <div>
    <InlineSVG src={DragdropIcon} className="-dragdrop-icon" />
    <p className="-drop-text">DROP HERE</p>

    <p className="-drag-text">
      <span>DRAG & DROP</span>
      <br /> <span>OR</span>
    </p>
    <div>
      <label className="-select-button">Select Files</label>
    </div>
  </div>
);

export default DropArea;



// WEBPACK FOOTER //
// ./src/scenes/NewCase/components/DropArea/index.js